import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AcidRefluxPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Acid Reflux</h1>
        <section className="mb-8">
          <p>Acid reflux is a digestive disorder where stomach acid flows back into the esophagus, causing heartburn and discomfort. Our natural therapies focus on soothing the digestive tract, reducing acid production, and promoting long-term digestive health through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Poor dietary habits</li>
            <li>Obesity</li>
            <li>Hiatal hernia</li>
            <li>Smoking and alcohol</li>
            <li>Stress</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Heartburn</li>
            <li>Regurgitation</li>
            <li>Chest pain</li>
            <li>Difficulty swallowing</li>
            <li>Sore throat</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use soothing herbs, acid-reducing remedies, and dietary modifications to naturally treat acid reflux. Our approach focuses on healing the digestive tract and preventing recurrence through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduced acid production</li>
            <li>Soothes digestive tract</li>
            <li>No harsh side effects</li>
            <li>Long-term relief</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat smaller, frequent meals</li>
            <li>Avoid spicy and fatty foods</li>
            <li>Maintain healthy weight</li>
            <li>Elevate head while sleeping</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 2-4 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing root causes.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from acid reflux—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default AcidRefluxPage; 